// extracted by mini-css-extract-plugin
export default {"root":"IconMagnifyingGlass_root__SVVu-"};